// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Spinner_spinnerContainer__J7zD0","spinner":"Spinner_spinner__Wamde","fadeIn":"Spinner_fadeIn__P7tfc","spin":"Spinner_spin__Auza9"};